import { APICore } from "./apiCore";

const api = new APICore();

// Coupons
function addCouponsApi(params: {
  coupon_code: string;
  start_in: string;
  expire_in: string;
  max_apply_limit: string;
  coupon_percentage: string;
  commision_percentage: string;
  influencer: number;
}) {
  const baseUrl = "/coupons";
  return api.create(`${baseUrl}`, params);
}

function getCouponsApi() {
  const baseUrl = "/coupons";
  return api.get(`${baseUrl}`, {});
}

function getInfluencerCouponsApi(influencer: number) {
  const baseUrl = "/influencer-coupons";
  return api.get(`${baseUrl}/${influencer}`, {});
}

function updateCouponsApi(
  id: string,
  params: {
    coupon_code: string;
    expire_in: string;
    start_in: string;
    max_apply_limit: string;
    coupon_percentage: string;
    commision_percentage: string;
    influencer: number;
  }
) {
  const baseUrl = `/coupons/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deleteCouponsApi(id: string) {
  const baseUrl = `/coupons/${id}`;
  return api.delete(`${baseUrl}`);
}

function getCouponsReportApi(type: string, from?: string, to?: string) {
  const baseUrl = `/influencer-orders`;
  const params: any = {
    influencer: type,
  };

  if (from) {
    params.from = from;
  }
  if (to) {
    params.to = to;
  }

  return api.get(`${baseUrl}`, params);
}

export { addCouponsApi, getCouponsApi, updateCouponsApi, deleteCouponsApi, getCouponsReportApi, getInfluencerCouponsApi };
